module.exports = __webpack_public_path__ + "fonts/Inter-400-vietnamese26.9df1755.woff2";